import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../../core/auth/auth.service';
import {ActivatedRoute} from '@angular/router';
import {SessionStorageService} from "@shared/services/session-storage.service";
import {SESSION_STORAGE_KEYS} from "@shared/constants/session-storage";

@Component({
  selector: 'app-sso-login-redirect',
  imports: [],
  templateUrl: './sso-login-redirect.component.html',
})
export class SsoLoginRedirectComponent implements OnInit {

  constructor(private readonly authService: AuthService,
              private readonly activatedRoute: ActivatedRoute,
              private readonly sessionStorageService: SessionStorageService){}

  ngOnInit(): void {
    const provider = this.activatedRoute.snapshot.data.ssoIdentifier;
    const page = this.activatedRoute.snapshot.queryParamMap.get('page');

    this.setStorageItem(provider, page);
    this.authService.startLoginFlow();
  }

  private setStorageItem(provider: string, page: string): void {
    localStorage.setItem('provider', provider);
    this.sessionStorageService.set(SESSION_STORAGE_KEYS.edenredOneToPage, page);
  }

}
